/*
	Events for the documents component
 */

/*
getOnDocumentSelected is a function that returns a function that sets the selected property of a document,
of a certain section in a certain group, whose checkbox has been clicked
 */
export const getOnDocumentSelected = (documents, setDocuments) => {
	return (sectionKey, groupIndex, documentIndex, selected) => {
		const newDocuments = { ...documents };
		newDocuments[sectionKey].groups.forEach((group, gIndex) => {
			group.documents.forEach((document, dIndex) => {
				if (groupIndex === gIndex && documentIndex === dIndex) {
					document.selected = selected;
				}
			});
		});
		setDocuments(newDocuments);
	};
};

/*
getOnAllDocumentsSelected is a function that returns a function that cancel
the selection of all the documents of a certain section
 */
export const getOnCancelSelection = (documents, setDocuments) => {
	return (sectionKey) => {
		const newDocuments = { ...documents };
		newDocuments[sectionKey].groups.forEach((group) => {
			group.documents.forEach((document) => {
				document.selected = false;
			});
		});
		setDocuments(newDocuments);
	}
};

/*
getOnSearchFilterChanged is a function that returns a function that filters the documents
based on the search input
 */
export const getOnSearchFilterChanged = (documents, setDocuments) => {
	return (search) => {
		if (search === "") {
			// Make visible all the documents
			const newDocuments = { ...documents };
			Object.keys(newDocuments).forEach((sectionKey) => {
				newDocuments[sectionKey].groups.forEach((group) => {
					group.documents.forEach((document) => {
						document.visible = true;
					});
				});
			});
			setDocuments(newDocuments);
		} else {
			// Make visible only the documents that match the search
			const newDocuments = { ...documents };
			Object.keys(newDocuments).forEach((sectionKey) => {
				newDocuments[sectionKey].groups.forEach((group) => {
					group.documents.forEach((document) => {
						document.visible = document?.name?.toLowerCase().includes(search.toLowerCase());
					});
				});
			});
			setDocuments(newDocuments);
		}
	};
};


export const getOnSelectAllSectionDocuments = (documents, setDocuments) => {
	return (sectionKey, selected) => {
		const newDocuments = {...documents};
		newDocuments[sectionKey].groups.forEach((group) => {
			group.documents.forEach((document) => {
				document.selected = selected;
			});
		});
		setDocuments(newDocuments);
	}
}


export const getOnSelectAllGroupDocuments = (documents, setDocuments) => {
	return (sectionKey, groupIndex, selected) => {
		const newDocuments = {...documents};
		newDocuments[sectionKey].groups[groupIndex].documents.forEach((document) => {
			document.selected = selected;
		});
		setDocuments(newDocuments);
	}
}